import { SVGProps, Ref, forwardRef, useId } from 'react';

export const EsiaBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path
                d="M21.9 8.298c-.087-1.134-.953-2.588-1.818-3.285a33 33 0 0 0-3.029-1.977 34 34 0 0 0-3.202-1.686A4.65 4.65 0 0 0 12.005 1a4.55 4.55 0 0 0-1.846.349 34 34 0 0 0-3.202 1.686C5.284 4.053 3.928 5.013 3.928 5.013a5.4 5.4 0 0 0-1.584 2.27.24.24 0 0 0 .23.317h1.383a.54.54 0 0 0 .452-.262c.246-.4.556-.761.922-1.068 0 0 1.12-.786 2.501-1.62a28 28 0 0 1 2.644-1.383A3.8 3.8 0 0 1 12 2.98a3.9 3.9 0 0 1 1.524.286q1.36.62 2.644 1.383a27 27 0 0 1 2.501 1.62c.715.573 1.429 1.764 1.5 2.694 0 0 .167 1.383.191 3.02a28 28 0 0 1-.167 3.028 4.4 4.4 0 0 1-1.524 2.694s-1.12.81-2.5 1.644q-1.287.763-2.645 1.383c-.483.2-1.002.297-1.524.286a3.9 3.9 0 0 1-1.524-.279 28 28 0 0 1-2.644-1.382 31 31 0 0 1-2.5-1.645c-.32-.255-.638-.634-.902-1.057a.53.53 0 0 0-.446-.256H2.58c-.17 0-.29.164-.227.322.346.872.96 1.75 1.575 2.245 0 0 1.356 1.017 3.029 2.006a34 34 0 0 0 3.202 1.686 4.65 4.65 0 0 0 1.846.34 4.55 4.55 0 0 0 1.846-.349 34 34 0 0 0 3.202-1.686c1.673-1.018 3.029-2.006 3.029-2.006a5.4 5.4 0 0 0 1.846-3.285q.2-1.84.202-3.692a40 40 0 0 0-.23-3.683"
                fill={`url(#${_uniqueId}paint0_linear_107_463)`}
                suppressHydrationWarning
            />
            <path
                d="M1.88 9.581a.44.44 0 0 1 .44-.44h6.82a.44.44 0 0 1 .44.44v1.32a.44.44 0 0 1-.44.44H1.88z"
                fill="#0066B3"
            />
            <path
                d="M1.88 12.66h13.86a.44.44 0 0 1 .44.44v1.32a.44.44 0 0 1-.44.44H2.32a.44.44 0 0 1-.44-.44z"
                fill="#EE2F53"
            />
            <defs>
                <linearGradient
                    id={`${_uniqueId}paint0_linear_107_463`}
                    x1={12.184}
                    y1={1}
                    x2={12.184}
                    y2={23}
                    gradientUnits="userSpaceOnUse"
                    suppressHydrationWarning
                >
                    <stop stopColor="#0066B3" />
                    <stop offset={0.354} stopColor="#0066B3" />
                    <stop offset={0.688} stopColor="#EE2F53" />
                    <stop offset={1} stopColor="#EE2F53" />
                </linearGradient>
            </defs>
        </svg>
    );
});
EsiaBrandSize24Glyph.displayName = 'EsiaBrandSize24Glyph';
